import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import createTranslator from "../../util/translationHelper";
import messages from "./translations/messages";

function useStatusModal({ onClose }) {
  const BLOCK = useRef("status-modal");
  const [visible, setVisible] = useState(true);

  const translate = useMemo(() => {
    return createTranslator(messages);
  }, [createTranslator, messages]);

  const handleClose = useCallback(() => {
    setVisible(false);
    if (onClose) onClose();
  }, [onClose]);

  // Auto-close the modal after 5 seconds
  useEffect(() => {
    const timer = setTimeout(() => {
      handleClose();
    }, 5000);
    return () => clearTimeout(timer);
  }, [handleClose]);

  return {
    BLOCK,
    translate,
    visible,
    handleClose,
  };
}

const Hook = {
  useStatusModal,
};

export default Hook;
